function productSearchPanelRecalcSetModel($form) {
    const $model = $form.find('[name="model"]');

    if (!$model.length) {
        return;
    }

    const $productIdItems = $form.find('.product-id-item');
    let empty = true;

    if ($productIdItems.length) {
        $productIdItems.each(function (index, item) {
            const $item = $(item);

            if ($item.val().length) {
                empty = false;
                return false;
            }
        });
    }

    if (empty) {
        $model.val('');
        $model.removeClass('valid');
    } else {
        $model.val(1);
        $model.addClass('valid');
    }

    $model[0].dispatchEvent(new Event('change', { bubbles: true }));
    $model[0].dispatchEvent(new Event('focusout', { bubbles: true }));
}

function productSearchPanelInsertSelectedItem($form, productId, model, name, city = '', serial = '') {
    const $items = $form.find('.js-form-chips');
    const $productIdItems = $form.find('.product-id-item');
    const $productIdItem = $productIdItems.filter(function () {
        return String($(this).data('product-id')) === String(productId);
    });

    if (!$productIdItem.length) {
        if ($items.length) {
            const $item = $('<li class="selected-filters__item selected-filters__item--gray js-form-chips-item"></li>');
            const $label = $('<span class="selected-filters__item-link"></span>').text(name || '');
            const $button = $('<button type="button" class="selected-filters__item-remove js-form-chips-item-del">Remove</button>')
                .attr('data-product-id', productId || '');

            $item.append($label, $button);
            $items.append($item);
        }

        $productIdItems.each(function (index, item) {
            const $item = $(item);

            if (!$item.val().length) {
                $item.val((productId || '') + '||' + (model || ''));
                $item.data('product-id', productId).attr('data-product-id', productId || '');

                $item.addClass('valid');
                $item.closest('.js-field').removeClass('field__error');
                $item[0].dispatchEvent(new Event('change', { bubbles: true }));

                return false;
            }
        });
    }

    const $modalContent = $form.closest('.modal__content');
    const $modalSubtitle = $modalContent.find('.waranty-block__model');
    if ($modalSubtitle.length && model) {
        $modalSubtitle.text(model);
    }

    const $modelDescrValue = $modalContent.find('.model-descr__value');
    if ($modelDescrValue.length && model) {
        $modelDescrValue.text(model);
    }

    const $serialDescrValue = $modalContent.find('.serial-descr__value');
    if ($serialDescrValue.length && serial) {
        $serialDescrValue.text(serial);
    }

    const $blockLocationText = $modalContent.find('.block-location__text');
    if ($blockLocationText.length && city) {
        $blockLocationText.text(city);
    }
}

function productSearchPanelResetForm($form) {
    const $items = $form.find('.js-form-chips');
    const $panel = $form.find('.js-search-panel-list');
    const $productIdItems = $form.find('.product-id-item');

    if ($productIdItems.length) {
        $productIdItems.each(function (index, item) {
            const $item = $(item);
            $item.val('');
            $item.data('product-id', '').attr('data-product-id', '');
            $item.removeClass('valid');
            $item.closest('.js-field').removeClass('field__error');
            $item[0].dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    if ($items.length) {
        $items.html('');
    }

    if ($panel.length) {
        $panel.html('');
    }
}

function productSearchPanelRenderItems(items) {
    const $fragment = $(document.createDocumentFragment());

    items.forEach(function (item) {
        const $row = $('<div class="product-row-item"></div>')
            .attr('data-name', item.ext_name || '')
            .attr('data-model', item.name || '')
            .attr('data-product-id', item.id || '');
        const $image = $('<div class="product-row-item__img"></div>');
        const $imageInner = $('<div class="product-row-item__img-inner"></div>');
        const $img = $('<img>')
            .attr('src', item.photo || '')
            .attr('alt', item.ext_name || '');
        const $text = $('<div class="product-row-item__text"></div>').text(item.ext_name || '');

        $imageInner.append($img);
        $image.append($imageInner);
        $row.append($image, $text);
        $fragment.append($row);
    });

    return $fragment;
}

let productSearchPanelTimer = null;
let productSearchPanelRequestId = 0;

$(document).on('click', '.js-form-chips-item-del', function (e) {
    e.preventDefault();

    const $this = $(this);
    const $form = $this.closest('form');
    const productId = $this.data('product-id');
    const $productIdItem = $form.find('.product-id-item').filter(function () {
        return String($(this).data('product-id')) === String(productId);
    });

    $this.closest('.js-form-chips-item').remove();

    if ($productIdItem.length) {
        $productIdItem.val('');
        $productIdItem.data('product-id', '').attr('data-product-id', '');
    }

    productSearchPanelRecalcSetModel($form);
    return false;
});

$(document).on('click', '.js-search-panel-list .product-row-item', function (e) {
    e.preventDefault();

    const $this = $(this);
    const $form = $this.closest('form');
    const productId = $this.data('product-id');
    const name = $this.data('name');
    const model = $this.data('model');
    const $searchPanel = $form.find('.js-search-panel');

    $searchPanel.removeClass('is-open');

    productSearchPanelInsertSelectedItem($form, productId, model, name);
    return false;
});

$(document).on('blur', '.js-search-panel-input', function () {
    const $form = $(this).closest('form');

    setTimeout(function () {
        const $panel = $form.find('.js-search-panel');

        if ($panel.length) {
            $panel.removeClass('is-open');
        }
    }, 100);
});

$(document).on('input focus', '.js-search-panel-input', function () {
    const $input = $(this);
    const $form = $input.closest('form');
    const q = this.value;
    const requestId = ++productSearchPanelRequestId;

    clearTimeout(productSearchPanelTimer);

    if (q.length < 2) {
        $form.find('.js-search-panel').removeClass('is-open');
        $form.find('.js-search-panel-list').html('');
        return;
    }

    productSearchPanelTimer = setTimeout(function () {
        fetch('/api/products/search/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                brand: 'mr',
                query: q
            }),
        })
            .then(res => res.json())
            .then(data => {
                if (requestId !== productSearchPanelRequestId) {
                    return;
                }

                const items = Array.isArray(data.items) ? data.items : [];
                const $list = $form.find('.js-search-panel-list');

                $list.html('');
                $list.append(productSearchPanelRenderItems(items));

                if (items.length) {
                    $form.find('.js-search-panel').addClass('is-open');
                } else {
                    $form.find('.js-search-panel').removeClass('is-open');
                }
            })
            .catch(err => console.error(err));
    }, 300);
});

$(document).on('reset', '[data-modal="#order-install"] form', function () {
    productSearchPanelResetForm($(this));
});

window.productSearchPanel = {
    resetForm: productSearchPanelResetForm,
    insertSelectedItem: productSearchPanelInsertSelectedItem,
};
